import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const ViewBlock = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
      }}
    >
      {children}
    </Box>
  );
};

const ChanceTemplate = ({ children, chance, error, loading }) => {
  // 1. 에러 발생 시 처리
  if (error) {
    if (error?.response?.status === 404) {
      return <ViewBlock>존재하지 않는 데이터입니다.</ViewBlock>;
    }
    return <ViewBlock>오류 발생</ViewBlock>;
  }

  // 2. 로딩 중이거나 필수 데이터(chance)가 아직 없을 때
  // 이 기간에는 children을 아예 렌더링하지 않음으로써 Tabs 에러를 방지합니다.
  if (loading || !chance) {
    return (
      <ViewBlock>
        <CircularProgress />
      </ViewBlock>
    );
  }

  // 3. 데이터 로드가 완료되면 자식 컴포넌트들을 정상적으로 렌더링합니다.
  return <Box>{children}</Box>;
};

export default ChanceTemplate;
